export const SHORT_REDIRECT_TIME = 5000;
export const LONG_REDIRECT_TIME = 7500;

export const HOME_REDIRECT_URL = '/';
export const LOGIN_URL = '/zaloguj';
export const LOGOUT_REDIRECT_URL = '/user/logout';
export const ONBOARDING_URL = '/rejestracja';
export const ONBOARDING_THANK_YOU_URL = '/rejestracja/dziekujemy';
export const ONBOARDING_ACTIVATE_URL = '/onboarding/confirmation';
export const CONTACT_URL = '/kontakt';
export const ABOUT_URL = '/onas';

export const RESET_PASSWORD_REDIRECT_URL = '/haslo/reset';
export const RESET_PASSWORD_SUCCESS_REDIRECT_URL = '/haslo/reset/sukces';
export const CHANGE_PASSWORD_REDIRECT_URL = '/haslo/zmiana';
export const USER_SETTINGS_URL = '/ustawienia';

export const TERMS_OF_SERVICE_URL = '/terms';
export const PRIVACY_POLICY_URL = '/privacy';
